import AgentCharge from "../../../../src/events/2022/01/agent-charge/main";
import * as React from 'react';
export default {
  AgentCharge,
  React
};